import React, { useEffect } from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import AIServices from "./components/AIServices";
import ConsultingServices from "./components/ConsultingServices";
import Portfolio from "./components/Portfolio";
import Contact from "./components/Contact";
import NeuralNetwork from "./components/NeuralNetwork";

function App() {
  useEffect(() => {
    // Smooth scroll behaviour
    const handleScroll = () => {
      const sections = document.querySelectorAll("section");
      const scrollPosition = window.scrollY + 100;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.clientHeight;

        if (
          scrollPosition >= sectionTop &&
          scrollPosition < sectionTop + sectionHeight
        ) {
          const current = section.getAttribute("id");
          const navLinks = document.querySelectorAll(".nav-link");

          navLinks.forEach((link) => {
            link.classList.remove("active");
            if (link.getAttribute("href") === `#${current}`) {
              link.classList.add("active");
            }
          });
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="App">
      <NeuralNetwork />
      <Header />
      <main>
        <Hero />
        <Services />
        <AIServices />
        <ConsultingServices />
        <Portfolio />
        <Contact />
      </main>
      <footer className="footer">
        <div className="container">
          <p>&copy; 2025 SPA Holdings. All rights reserved.</p>
          <p>Empowering businesses through innovative technology solutions</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
